import { combineReducers } from 'redux';

import {
  EMPLOYEE_ROLE_OPEN_RIGHT_COLUMN,
  EMPLOYEE_ROLE_CLOSE_RIGHT_COLUMN,
  EMPLOYEE_ROLE_SET_ROLES,
  EMPLOYEE_ROLE_SET_ROLE_DETAIL,
  EMPLOYEE_ROLE_SET_ASSIGNABLE_PERMISSIONS,
  EMPLOYEE_ROLE_SET_ERROR,
  EMPLOYEE_ROLE_IS_SUBMITTING_FORM,
} from '../../actions/employees/role/constants';
import createReducer from '../../utils/createReducer';

const assignablePermissions = createReducer([], {
  [EMPLOYEE_ROLE_SET_ASSIGNABLE_PERMISSIONS]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.permissions,
});

const currentPage = createReducer(null, {});

const error = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [EMPLOYEE_ROLE_SET_ERROR]: (draft, { payload }) => payload.error,
});

const isSubmittingForm = createReducer(false, {
  [EMPLOYEE_ROLE_IS_SUBMITTING_FORM]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.isSubmittingForm,
});

const openRightColumn = createReducer(false, {
  [EMPLOYEE_ROLE_OPEN_RIGHT_COLUMN]: () => true,
  [EMPLOYEE_ROLE_CLOSE_RIGHT_COLUMN]: () => false,
});

const roleDetail = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [EMPLOYEE_ROLE_SET_ROLE_DETAIL]: (draft, { payload }) => payload.role,
});

const roles = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [EMPLOYEE_ROLE_SET_ROLES]: (draft, { payload }) => payload.roles,
});

const totalPage = createReducer(null, {});

export default combineReducers({
  assignablePermissions,
  currentPage,
  error,
  isSubmittingForm,
  openRightColumn,
  roleDetail,
  roles,
  totalPage,
});
